import BreadcrumbSkeleton from "components/skeleton/breadcrumb-1";
import Breadcrumb from "components/shared/breadcrumb";
import { useEffect, useState, memo } from "react";
import { useLocation, Link } from "react-router-dom";
import { unixToShamsi } from "utils/convert-utils";
import UseFetch from "hooks/useFetch";
import { useDispatch } from "react-redux";
import { fetchMessages } from "redux/slices/main";

const Edit = props => {
    const {
        pageData,
        id,
        setServerBreadcrumbDataCallback,
        serverBreadcrumb
    } = props;

    const location = useLocation();
    const dispatch = useDispatch();

    const [fetchUrl, setFetchUrl] = useState();
    const { isLoading, data, error } = UseFetch(fetchUrl);
    const urlParams = new URLSearchParams(location.search);

    useEffect(() => {
        if (!isLoading && !error)
            dispatch(fetchMessages());

        // eslint-disable-next-line
    }, [isLoading, data, error])

    useEffect(() => {
        if (pageData)
            setFetchUrl(pageData.get_url.replace(":id", id));
        // eslint-disable-next-line
    }, [pageData, id])

    useEffect(() => {
        if (data && data.breadcrumbs?.length)
            setServerBreadcrumbDataCallback(data.breadcrumbs);
        else
            setServerBreadcrumbDataCallback([]);
        // eslint-disable-next-line
    }, [data])

    const getPreviousRoute = () => {
        const splitedRoute = location.pathname.split("/");
        splitedRoute.pop();

        let previousRoute = splitedRoute.join("/");
        const validParams = [];

        if (pageData && pageData.add_valid_params)
            pageData.add_valid_params.forEach(param => {
                const paramValue = urlParams.get(param);
                if (paramValue)
                    validParams.push(`${param}=${paramValue}`);
            })

        if (validParams.length)
            previousRoute += `?${validParams.join("&")}`;

        return previousRoute;
    }

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">جزئیات پیام</h1>

                    {
                        !isLoading ? (
                            serverBreadcrumb.length
                                ? <Breadcrumb data={serverBreadcrumb} />
                                : <Breadcrumb data={pageData.breadcrumb} />
                        ) : (
                            <BreadcrumbSkeleton />
                        )
                    }
                </div>

                <div className="flex">
                    <Link to={getPreviousRoute()} className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center">
                        <i className="fa-regular fa-arrow-right"></i>
                    </Link>
                </div>
            </div>

            <div className="wrap-box tp-22">
                {
                    !isLoading ? (
                        !error ? (
                            <div className="text-slate-900 dark:text-slate-100">
                                <div className="text-sm mb-3 flex justify-between">
                                    {
                                        data.data.meta?.link ? (
                                            <Link
                                                className="bg-primary-100 hover:bg-primary-200 transition-colors text-xs text-white w-6 h-6 fit-center rounded-full items-center"
                                                to={data.data.meta.link}
                                            >
                                                <i className="fa-regular fa-link"></i>
                                            </Link>
                                        ) : <div></div>
                                    }

                                    {data?.data?.created_at ? unixToShamsi(data?.data?.created_at) : ""}
                                </div>

                                <b className="block font-medium">عنوان</b>
                                <span className="text-sm">{data?.data?.subject}</span>

                                <b className="block font-medium mt-4">متن</b>
                                <span className="text-sm">{data?.data?.text}</span>
                            </div>
                        ) : <p className="font-medium text-sm text-red-500 text-center">خطا در دریافت اطلاعات!</p>
                    ) : <></>
                }
            </div >
        </>
    )
}

export default memo(Edit);